export type VendorSortTuple = [number, number, number];

const DEFAULT_SORT: VendorSortTuple = [0, 0, 0];
const SORT_STORAGE_KEY = "vendor_store_sort";
const SORT_STORAGE_KEY_SEARCH = "vendor_store_sort_search";

export function readVendorSortFromStorage(isSearch: boolean): VendorSortTuple {
	if (process.env.IS_SERVER || typeof window === "undefined") {
		return DEFAULT_SORT;
	}

	try {
		const key = isSearch ? SORT_STORAGE_KEY_SEARCH : SORT_STORAGE_KEY;
		const storedSort = window.localStorage.getItem(key);

		if (!storedSort) {
			return DEFAULT_SORT;
		}

		const parsedSort = JSON.parse(storedSort);
		if (!Array.isArray(parsedSort) || parsedSort.length !== 3) {
			return DEFAULT_SORT;
		}

		return parsedSort.map((value) => (Number(value) === 1 ? 1 : 0)) as [
			number,
			number,
			number
		];
	} catch {
		return DEFAULT_SORT;
	}
}

export function persistVendorSortToStorage(
	sort: VendorSortTuple,
	isSearch: boolean
) {
	if (process.env.IS_SERVER || typeof window === "undefined") {
		return;
	}
	const key = isSearch ? SORT_STORAGE_KEY_SEARCH : SORT_STORAGE_KEY;

	try {
		window.localStorage.setItem(key, JSON.stringify(sort));
	} catch {
		// Ignore storage errors (quota/private mode) and keep in-memory value.
	}
}
